import { __ } from '@wordpress/i18n'

export const popupPresets = [
    {
        id: 'default',
        name: __('Default', 'translatepress-multilingual'),
        settings: {
            backgroundColor: '#ffffff',
            textColor: '#143852',
            buttonBackgroundColor: '#143852',
            buttonBorderColor: '#143852',
            buttonHoverColor: '#0f2a3d',
            buttonTextColor: '#ffffff',
            buttonHoverTextColor: '#ffffff',
            closeTextColor: '#143852',
            aldSwitcherBackgroundColor: '#ffffff',
            aldSwitcherBackgroundHoverColor: '#143852',
            aldSwitcherTextColor: '#143852',
            aldSwitcherTextHoverColor: '#ffffff',
            aldSwitcherBorderColor: '#14385233',
            aldSwitcherBorderWidth: 1,
            aldSwitcherBorderRadius: 5,
            borderColor: '#1438521A',
            borderWidth: 1,
            borderRadius: 4,
            overlayColor: '#00000080',
            popupAnimationEnabled: true,
            popupAnimation: 'fade',
        },
    },
    {
        id: 'minimal-light',
        name: __('Minimal Light', 'translatepress-multilingual'),
        settings: {
            backgroundColor: '#ffffff',
            textColor: '#1D2327',
            buttonBackgroundColor: '#1D2327',
            buttonBorderColor: '#1D2327',
            buttonHoverColor: '#3C434A',
            buttonTextColor: '#ffffff',
            buttonHoverTextColor: '#ffffff',
            closeTextColor: '#50575E',
            aldSwitcherBackgroundColor: '#ffffff',
            aldSwitcherBackgroundHoverColor: '#3C434A',
            aldSwitcherTextColor: '#1D2327',
            aldSwitcherTextHoverColor: '#ffffff',
            aldSwitcherBorderColor: '#DCDCDE',
            aldSwitcherBorderWidth: 1,
            aldSwitcherBorderRadius: 2,
            borderColor: '#DCDCDE',
            borderWidth: 1,
            borderRadius: 2,
            overlayColor: '#F0F0F199',
        },
    },
    {
        id: 'dark-overlay',
        name: __('Dark Overlay', 'translatepress-multilingual'),
        settings: {
            backgroundColor: '#1D2327',
            textColor: '#ffffff',
            buttonBackgroundColor: '#2271B1',
            buttonBorderColor: '#2271B1',
            buttonHoverColor: '#135E96',
            buttonTextColor: '#ffffff',
            buttonHoverTextColor: '#ffffff',
            closeTextColor: '#C3C4C7',
            borderColor: '#3C434A',
            aldSwitcherBackgroundColor: '#ffffff',
            aldSwitcherBackgroundHoverColor: '#2271B1',
            aldSwitcherTextColor: '#1D2327',
            aldSwitcherTextHoverColor: '#ffffff',
            aldSwitcherBorderColor: '#6B7280',
            aldSwitcherBorderWidth: 1,
            aldSwitcherBorderRadius: 6,
            borderWidth: 1,
            borderRadius: 6,
            overlayColor: '#000000B3',
        },
    },
    {
        id: 'brand-blue',
        name: __('Brand Blue', 'translatepress-multilingual'),
        settings: {
            backgroundColor: '#F6FBFF',
            textColor: '#143852',
            buttonBackgroundColor: '#2271B1',
            buttonBorderColor: '#0A7CC2',
            buttonHoverColor: '#135E96',
            buttonTextColor: '#ffffff',
            buttonHoverTextColor: '#ffffff',
            closeTextColor: '#2271B1',
            aldSwitcherBackgroundColor: '#ffffff',
            aldSwitcherBackgroundHoverColor: '#135E96',
            aldSwitcherTextColor: '#143852',
            aldSwitcherTextHoverColor: '#ffffff',
            aldSwitcherBorderColor: '#8BC5F0',
            aldSwitcherBorderWidth: 1,
            aldSwitcherBorderRadius: 8,
            borderColor: '#8BC5F0',
            borderWidth: 1,
            borderRadius: 8,
            overlayColor: '#14385266',
        },
    },
    {
        id: 'bordered',
        name: __('Bordered', 'translatepress-multilingual'),
        settings: {
            backgroundColor: '#ffffff',
            textColor: '#143852',
            buttonBackgroundColor: '#ffffff',
            buttonBorderColor: '#0F2A3D',
            buttonHoverColor: '#143852',
            buttonTextColor: '#143852',
            buttonHoverTextColor: '#ffffff',
            closeTextColor: '#143852',
            aldSwitcherBackgroundColor: '#ffffff',
            aldSwitcherBackgroundHoverColor: '#0F2A3D',
            aldSwitcherTextColor: '#0F2A3D',
            aldSwitcherTextHoverColor: '#ffffff',
            aldSwitcherBorderColor: '#0F2A3D',
            aldSwitcherBorderWidth: 1,
            aldSwitcherBorderRadius: 3,
            borderColor: '#143852',
            borderWidth: 2,
            borderRadius: 0,
            overlayColor: '#FFFFFFCC',
        },
    },
    {
        id: 'transparent',
        name: __('Transparent', 'translatepress-multilingual'),
        settings: {
            backgroundColor: '#FFFFFFE6',
            textColor: '#1D2327',
            buttonBackgroundColor: '#1D2327',
            buttonBorderColor: '#000000',
            buttonHoverColor: '#000000',
            buttonTextColor: '#ffffff',
            buttonHoverTextColor: '#ffffff',
            closeTextColor: '#50575E',
            aldSwitcherBackgroundColor: '#ffffff',
            aldSwitcherBackgroundHoverColor: '#000000',
            aldSwitcherTextColor: '#1D2327',
            aldSwitcherTextHoverColor: '#ffffff',
            aldSwitcherBorderColor: '#1D232733',
            aldSwitcherBorderWidth: 1,
            aldSwitcherBorderRadius: 8,
            borderColor: '#FFFFFF99',
            borderWidth: 1,
            borderRadius: 8,
            overlayColor: '#00000033',
        },
    },
]
